<template>
  <el-dialog
    :visible.sync="visible"
    append-to-body
    :show-close="true"
    :center="true"
    :before-close="handleClose"
    title="评价"
    width="500px"
  >
    <div>
      <el-form ref="form" :model="formData"  :rules="rules" label-width="100px">
            <el-form-item label="管理水平" >  
                <el-rate
                  v-model="formData.manage_rank"
                  :colors="colors">
                </el-rate>
            </el-form-item>
            <el-form-item label="薪资水平" >  
                <el-rate
                  v-model="formData.pay_rank"
                  :colors="colors">
                </el-rate>
            </el-form-item>
            <el-form-item label="组织沟通" >  
              <el-rate
                v-model="formData.link_rank"
                :colors="colors">
              </el-rate>
           </el-form-item>


            <el-form-item label="综合评分" >  
                <el-rate
                  v-model="formData.com_rank	"
                  :colors="colors">
                </el-rate>
            </el-form-item>

        <el-form-item label="评价内容"  prop="content">
          <el-input type="textarea" v-model="formData.content"></el-input>
        </el-form-item>


      </el-form>
    </div>
    <span slot="footer" class="dialog-footer">
      <el-button type="primary" @click="submit">提交</el-button>
      <el-button @click="visible = false">取 消</el-button>
    </span>


  </el-dialog>
</template>

<script>
import { jobEnrollAssesAdd}  from "@/api/personal/work/job/index.js";

export default {

  data() {
    return {
      visible: false,
      colors: ['#99A9BF', '#F7BA2A', '#FF9900'] ,

      /*enroll_id	是	int	报名id
        pay_rank	是	int	工作能力1-5
        link_rank	是	int	处事能力1-5
        com_rank	是	int	组织能力1-5
        manage_rank	是	int	综合能力1-5
        content	是	int	评价内容
        */
      formData: {
        enroll_id	:'',
        relation_status:'',
        manage_rank:1,
        pay_rank:1,
        link_rank:1,
        com_rank:1,
        content:''
      },
       rules: {
        content: [
              {required: true, message: '请填写评价内容', trigger: 'blur'}
          ],

       }
    };
  },

 
  mounted() {

},
  
  methods: {
    handleClose() {
      this.visible = false;
      this.$refs["form"].resetFields();

    },


    init(enroll_id,relation_status) {
      console.log(enroll_id);
      this.visible = true;
      this.formData.enroll_id=enroll_id;
      this.formData.relation_status=relation_status;
      
    },

   
    
    
    submit(){
      var that=this;
 
      this.$refs["form"].validate((valid) => {
          if (valid) {
            jobEnrollAssesAdd(that.formData).then((response) => {
              console.log(response);
              if(response.code==200){
                this.$message({
                   message: "提交成功",
                   type: 'success'
                });
                that.visible = false;
              
              }else{
                this.$message({
                  message: response.msg?response.msg:"提交失败",
                });
              }
            });
          } 
        });
    },

  },

 
};
</script>

<style lang="scss" scoped>
::v-deep .myWindow {
    border-radius: 15px;



.el-button--primary {
  color: #FFF;
  background-color: #717ebb;
  border-color: #717ebb;
}


/*
.footer{
  display: flex;
  justify-content: center;
}*/


  }
</style>
